// import { getZtCoreVersion } from '../../lib/libs'
// import { trace } from '../../lib/trace'
class Flutter {
  appInfo = {}
  constructor() {
    window._$ztflutter = {
      /**
       * flutter event 广播事件列表
       */
      eventMaps: new Map(),

      /**
       * flutter event 广播
       * @param {string} e
       */
      event: (name, e) => {
        switch (name) {
          /**
           * flutter event 广播
           * @param {string} e
           */
          case 'windowEvent':
            try {
              const eventData = JSON.parse(e.data)
              const { name, data } = eventData
              console.log('Flutter event 广播', name, data)
              const callback = window._$ztflutter.eventMaps.get(name)
              callback && callback(data)
            } catch (error) {
              console.error('Flutter event 广播异常', error)
            }
            break
          /**
           * Flutter 关闭窗口 广播
           * @param {string} e
           */
          case 'closeWindow':
            console.log('Flutter event 广播 closeWindow', e)
            window._$ztflutter.eventMaps.get(`onCloseWindow_${e.windowId}`) &&
              window._$ztflutter.eventMaps.get(`onCloseWindow_${e.windowId}`)()
            break
        }
      }
    }
  }
  /**
   * 打开一个新窗口
   * @param {*} data
   * @returns
   */
  openWindow(data) {
    return new Promise((resolve, reject) => {
      const params = {
        url: data.url,
        title: data.title,
        titleColor: '#000',
        color: '#fff'
      }
      window.flutter_inappwebview.callHandler('openWindow', JSON.stringify(params)).then((data) => {
        console.log('openWindowSuccess', data)
        resolve(data)
      })
    })
  }

  /**
   * 关闭一个window窗口, 不传则关闭当前window,传 0 则关闭所有window,传 win  则页面栈关闭到指定window
   * @param { string } id
   */
  closeWindow(id) {
    return window.flutter_inappwebview.callHandler('closeWindow', JSON.stringify(id ? { windowId: id } : {}))
  }

  /**
   * 发送消息
   * @param {string} name 消息名称
   * @param {Object} data 消息内容
   */
  postMessage(name, data) {
    window.flutter_inappwebview.callHandler(
      'windowEvent',
      JSON.stringify({
        params: {
          name,
          data
        }
      })
    )
    // window.$zhm.windowEvent(JSON.stringify({ name, data }))
  }
  /**
   * 接收消息
   * @param {string} name 消息名称
   * @param {Function} callback 回调函数，回调函数参数为消息内容
   */
  addEventListener(name, callback) {
    window._$ztflutter.eventMaps.set(name, callback)
  }
  /**
   * 移除消息监听
   * @param {string} name 消息名称
   */
  removeEventListener(name) {
    window._$ztflutter.eventMaps.delete(name)
  }

  /**
   * 关闭对应windowId页面时触发,只触发一次就会自动销毁
   * @param {string} id 页面id
   */
  addWindowCloseListener(id, callback) {
    window._$ztflutter.eventMaps.set(`onWindowClose_${id}`, () => {
      if (callback) {
        callback()
        window._$ztflutter.eventMaps.delete(`onWindowClose_${id}`)
      }
    })
  }
  /**
   * 移除关闭页面监听
   * @param {string} id 页面id
   */
  removeWindowCloseListener(id) {
    window._$ztflutter.eventMaps.delete(`onWindowClose_${id}`)
  }
}

export default new Flutter()
